import { useEffect, useState } from 'react';

import { useUserStrategies } from '../../../context/UserStrategies';

import { StrategyComposition } from './StrategyComposition';

import { CHART_COLORS } from '../../../constants/colors';

import { IStrategy } from '../../../types/model';
import { logger } from '../../../helpers/logger';
import { GridWidget } from '../types';
import { PlaceholderStrategy } from '../../Strategies/Placeholder';
import { t } from 'i18next';

const colors = Object.values(CHART_COLORS).map((c) => 'bg-' + c);

const columns = [
  'Name',
  'Invested',
  'Actual',
  'Net Change',
  '% 1D',
  '% 1W',
  '% 1M',
  '% 1YTD',
  // 'Max increase',
  // 'Max drawdown',
];

const categoryPercentage = (strategy: IStrategy) => {
  let categories: any = [],
    total_values = 0,
    colorIndex = 0;

  let assets = strategy.strategyAssets.items;

  for (let asset of Object.keys(assets)) {
    let name = assets[asset].strategyAssetCategory.title;

    let exist = false;

    if (!colors[colorIndex]) {
      colorIndex = 0;
    }

    for (let sub_cat of categories) {
      if (sub_cat.name === name) {
        sub_cat.total += 1;
        exist = true;
        break;
      }
    }

    if (!exist) {
      categories.push({
        name: name,
        total: 1,
        color: colors[colorIndex],
      });

      colorIndex += 1;
    }

    total_values += 1;
  }

  for (let category of Object.keys(categories)) {
    categories[category].perc =
      (100 * categories[category].total) / total_values;
  }

  return categories;
};

export const StrategiesComparison = ({
  height,
  standAlone,
  width,
  loading,
  setLegend,
}: GridWidget) => {
  const { strategies } = useUserStrategies();

  const [strategiesList, setStrategiesList] = useState<IStrategy[]>([]);

  useEffect(() => {
    const performanceStrategies = strategies.map((item) => ({
      ...item,
      calc_perc: categoryPercentage(item),
    }));

    setStrategiesList(performanceStrategies);

    logger.log('WidgetStrategiesPerformance:strategies', performanceStrategies);
  }, []);

  return strategies.length < 2 ? (
    <PlaceholderStrategy
      title={t('placeholders.compareStrategies.title')}
      subtitle={t('placeholders.compareStrategies.subtitle')}
    />
  ) : (
    <div
      className={`
        h-full
        overflow-y-auto
        text-xs
        content-center
        ${width < 1 && 'divide-grey-10 divide-y-6'}
      `}
    >
      {width > 1 && (
        <div
          className={`
            sticky
            top-0
            bg-white
            inline-grid
            grid-cols-${columns.length}
            py-3
            px-2
            w-full
            uppercase
            z-10
            border-b
            border-grey-10
            dark:border-grey-70
            dark:bg-grey-90
          `}
        >
          {columns.map((el) => (
            <div key={el} className={'flex items-center'}>
              {el}
            </div>
          ))}
        </div>
      )}
      {strategiesList.map((strategy, i) => (
        <StrategyComposition
          key={strategy.id}
          width={width}
          strategy={strategy}
        />
      ))}
    </div>
  );
};
